/**
 * UI Helper utilities
 */

export function getStatusBadgeClass(status) {
  const map = {
    'Open': 'badge-open',
    'In Progress': 'badge-in-progress',
    'Triaged': 'badge-in-progress',
    'Assigned to group': 'badge-in-progress',
    'Assigned': 'badge-assigned',
    'Resolution commenced': 'badge-in-progress',
    'Resolution completed': 'badge-resolution',
    'Verified': 'badge-resolution',
    'Communicated to client': 'badge-communicated',
    'Closed': 'badge-closed',
    'Rejected': 'badge-rejected',
  };
  return map[status] || 'badge-open';
}

export function getSeverityPillClass(level) {
  const map = {
    'Critical': 'pill-critical',
    'High': 'pill-high',
    'Medium': 'pill-medium',
    'Low': 'pill-low',
  };
  return map[level] || '';
}

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  const s = String(dateStr);
  const d = new Date(s.endsWith('Z') || s.includes('+') ? s : s + 'Z');
  return d.toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '-';
  const s = String(dateStr);
  const d = new Date(s.endsWith('Z') || s.includes('+') ? s : s + 'Z');
  return d.toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const hours = Math.floor(diff / 3600000);
  if (hours < 1) return 'just now';
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return formatDate(dateStr);
}
